import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { MoveToProjectDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  order_uid: string;
  data: MoveToProjectDTO;
}

export const useMoveToProjectQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ order_uid, data }: IParams) => {
      await Api.orders.postMoveToProject(order_uid, data);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      await client.invalidateQueries(['getOrder']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getOrder']);
    },
  });
};
